import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useGetOnboardingChecklistQuery } from '@/api/api-hooks';
import { AppSkeletonLoader } from '@/components/AppSkeletonLoader';
import { useIsOrgOrSourceAdmin } from '@/hooks/useIsOrgOrSourceAdmin';
import { useUser } from '@/hooks/useUser';

function OrganizationIndexComponent() {
  const navigate = useNavigate();
  const { organizationName } = Route.useParams();
  const { isMeLoading } = useUser();
  const isOrgOrSourceAdmin = useIsOrgOrSourceAdmin();
  const { data: checklist, isError } = useGetOnboardingChecklistQuery();

  useEffect(() => {
    // Wait for /me so admins aren't briefly treated as normal users
    // (isOrgOrSourceAdmin is false while it loads).
    if (isMeLoading) {
      return;
    }

    // Users who don't administer the org or any source can only view (not
    // manage) their sources, so MCP Setup is always their home page.
    if (!isOrgOrSourceAdmin) {
      navigate({
        to: '/$organizationName/mcp',
        params: { organizationName },
        replace: true,
      });
    } else if (checklist) {
      navigate({
        to: checklist.setup_mcp_completed_at ? '/$organizationName/library' : '/$organizationName/mcp',
        params: { organizationName },
        replace: true,
      });
    } else if (isError) {
      // Fallback to library if onboarding checklist fails to load
      navigate({
        to: '/$organizationName/library',
        params: { organizationName },
        replace: true,
      });
    }
  }, [checklist, isError, isMeLoading, isOrgOrSourceAdmin, navigate, organizationName]);

  return <AppSkeletonLoader />;
}

export const Route = createFileRoute('/$organizationName/')({
  component: OrganizationIndexComponent,
});
